import { classNames } from 'primereact/utils';
import React from 'react';
import { useAppSelector } from '../../hooks/hooks.js';
import { selectMode } from '../../store/reducers/enginePropertiesSlice.js';

const C2Container = (props) => {
    var _a, _b;
    const mode = useAppSelector(selectMode);
    const isHidden = mode === "live";
    props.className;
    if (!isHidden)
        (_a = props.className) === null || _a === void 0 ? void 0 : _a.split(" ").filter((c) => !c.includes("w-")).join(" ");
    const classes = classNames({
        "border-transparent": isHidden,
        "border-white-200": !isHidden,
        [(_b = props.className) !== null && _b !== void 0 ? _b : ""]: true,
    });
    return (React.createElement("div", Object.assign({}, props, { className: classes }), props.children));
};

export { C2Container as default };
//# sourceMappingURL=C2Container.js.map
